import { Menu, MenuItem } from '@mui/material';
import React, { useEffect, useState } from 'react';
import profile from '../../../assets/profile.jpg';
import { useSidebar } from '../../../context/SidebarContext';
import api from '../../../utils/api';
import LogoIcon from '../icons/LogoIcon';
import './Header.css';
import { useNavigate } from 'react-router-dom';
import UserProfileIcon from '../icons/UserProfileIcon';

interface HeaderProps {
  // Add any props if needed
}

const Header: React.FC<HeaderProps> = () => {
  const navigate = useNavigate();
  const { toggleSidebar, setMenu } = useSidebar();
  const [isLoading, setIsLoading] = useState(true);
  const [topMenus, setTopMenus] = useState<any[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedTopMenuId, setSelectedTopMenuId] = useState<number>(0);

  const open = Boolean(anchorEl);

  useEffect(() => {
    setIsLoading(true);
    api.get<{ data: any[] }>('/cmn/menu/top').then((res) => {
      setTopMenus(res.data.data ?? []);
      setSelectedTopMenuId(res.data.data[0].menuId);
      setIsLoading(false);
    }).catch((err) => {
      console.log(err);
      setIsLoading(false);
    })
  }, []);

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>, menuId: number) => {
    setSelectedTopMenuId(menuId);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSubMenuClick = (menuId: number) => {
    api.get<{ data: any[] }>(`/cmn/menu/left/${menuId}`).then((res) => {
      setIsLoading(false);
      setMenu({
        items: (res.data.data ?? []).map((item: any) => ({
          label: item.name,
          path: item.route
        }))
      });
      navigate(res.data.data[0].route);
    }).catch((err) => {
      console.log(err);
      setIsLoading(false);
    })
    handleClose();
  };

  return (
    <header className="top-header" id="top-header">
      <div className="header-left">
        <div className="logo logo-img">
          <LogoIcon />
        </div>
        <nav className="main-nav">
          {isLoading ? (
            <></>
          ) : (
            <>
              {topMenus.map((menu) => (
                <a
                  href="#"
                  key={menu.menuId}
                  aria-haspopup="true"
                  onClick={(e) => handleMenuClick(e, menu.menuId)}
                  aria-expanded={open ? 'true' : undefined}
                  aria-controls={open ? menu.menuId : undefined}
                  className={`nav-link ${menu.menuId === selectedTopMenuId ? 'active' : ''}`}
                >
                  {menu.name}
                </a>
              ))}
            </>
          )}
        </nav>
      </div>
      <div className="header-right">
        <div className="user-profile">
          <UserProfileIcon color="#FFFFFF" />
        </div>
        <button className="menu-btn" onClick={toggleSidebar}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.5 5H17.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2.5 10H17.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2.5 15H17.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <button className="dropdown-btn">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 7.5L10 12.5L15 7.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>

      {isLoading ? (
        <></>
      ) : (
        <>
          {topMenus.map((menu) => (
            <React.Fragment key={menu.menuId}>
              <Menu
                open={open}
                id={menu.menuId}
                anchorEl={anchorEl}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': menu.id,
                }}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                {menu.children.map((item: any) => (
                  <MenuItem onClick={() => handleSubMenuClick(item.menuId)} key={item.menuId}>{item.name}</MenuItem>
                ))}
              </Menu>
            </React.Fragment>
          ))}
        </>
      )}
    </header>
  );
};

export default Header; 